import { SpecSection } from 'Components/SpecSection/SpecSection';
import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';

import { DamageInfoBox } from './Components/DamageInfoBox';
import { conditionAndDamageFields } from './ConditionAndDamageSection.consts';
import type { ConditionAndDamageFieldValues } from './ConditionAndDamageSection.types';

export const ConditionAndDamageSection: React.FC = () => {
	const { conditionAndDamage, id, mainInfo, ratings } = useVehicleData();

	const fieldData: ConditionAndDamageFieldValues = {
		...conditionAndDamage,
		grade: ratings.grade,
		id,
		make: mainInfo.make,
		model: mainInfo.model,
		numericGrade: ratings.numericGrade,
	};

	return (
		<>
			<DamageInfoBox />
			<SpecSection data={fieldData} fields={conditionAndDamageFields} />
		</>
	);
};
